import { memo } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

const overlayVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0 },
};

const ArrowIcon = () => (
  <svg
    className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M5 12h14M12 5l7 7-7 7" />
  </svg>
);

const HeroOverlay = ({ isVisible }) => {
  const { t } = useTranslation();
  const heroOverlayData = t("components.home.heroOverlay", {
    returnObjects: true,
  });

  return (
    <motion.div
      variants={overlayVariants}
      initial="hidden"
      animate={isVisible ? "visible" : "hidden"}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className="w-[90%] lg:w-[50%] bg-black/70 backdrop-blur-lg p-8 
        rounded-3xl shadow-2xl"
    >
      <div className="space-y-4">
        <h2
          className="text-md md:text-lg lg:text-xl font-bold text-white 
          tracking-tight leading-tight"
        >
          {heroOverlayData.heading}
        </h2>
        <p className="text-sm md:text-md lg:text-lg text-gray-300 leading-relaxed">
          {heroOverlayData.description}
        </p>
        <Link to={heroOverlayData.link} className="inline-block">
          <button
            className="group flex items-center gap-2 text-sm md:text-md lg:text-lg text-gray-300 
              hover:text-white transition-colors duration-300 cursor-pointer"
          >
            <span>{heroOverlayData.buttonText}</span>
            <ArrowIcon />
          </button>
        </Link>
      </div>
    </motion.div>
  );
};

HeroOverlay.propTypes = {
  isVisible: PropTypes.bool.isRequired,
};

export default memo(HeroOverlay);
